import { EditorState, getDefaultKeyBinding, KeyBindingUtil } from 'draft-js';

const { hasCommandModifier } = KeyBindingUtil;

/**
 * @param {object} contentBlock The content block to search for link entities.
 * @param {Function} callback -
 * @param {object} contentState -
 */
export const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === 'LINK'
    );
  }, callback);
};

/**
 * Handles key bindings for the rich text editor.
 *
 * @param {KeyboardEvent} e - The keyboard event object.
 * @returns {object} An object containing the event and command to execute.
 */
export const myKeyBindingFn = (e) => {
  if (e.key === 's' /* `S` key */ && hasCommandModifier(e)) {
    return {
      e,
      command: 'myeditor-save',
    };
  }
  if (e.key === 'Tab') {
    return {
      e,
      command: 'tab',
    };
  }
  return getDefaultKeyBinding(e);
};

/**
 * Applies decorators to the given EditorState
 * @param {EditorState} editorState - The EditorState to apply decorators to
 * @returns {EditorState} The new EditorState with decorators applied
 */
export const isEditorStateEmpty = (editorState) => {
  const contentState = editorState.getCurrentContent();
  return !contentState.hasText();
};

/**
 * Applies a decorator to the given editorState
 * @param {EditorState} editorState The current editor state
 * @param {CompositeDecorator} decorator The decorator to apply
 * @returns {EditorState} The new editor state with the decorator applied
 */
export const applyDecorators = (editorState, decorator) =>
  EditorState.set(editorState, { decorator });
